<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.description"></p>
  @if ((loading$ | async)) {
    <mat-spinner class="spinner"></mat-spinner>
  }
  @if (!(loading$ | async)) {
    <tag-input
      [formControl]="templateTags"
      [onlyFromAutocomplete]="true"
      displayBy="name"
      identifyBy="id"
      [placeholder]="'program_template_tag_dialog.tag.add.placeholder' | translate"
      [secondaryPlaceholder]="'program_template_tag_dialog.tag.add.secondary_placeholder' | translate"
      >
      <tag-input-dropdown [showDropdownIfEmpty]="true" [autocompleteItems]="( allTags$ | async )" displayBy="name" identifyBy="id" [keepOpen]="false" [appendToBody]="false">
        <ng-template let-item="item" let-index="index">
          <div class="tag">
            @if (item.organization_unit_id === (currentOUId$ | async)) {
              <mat-icon>push_pin</mat-icon>
            }
            <span>
              {{ item.name }}
            </span>
          </div>
        </ng-template>
      </tag-input-dropdown>
    </tag-input>
  }
</div>
<div mat-dialog-actions>
  <button mat-button (click)="closeDialog()" color="primary" cdkFocusInitial>
    {{ 'generic.ok' | translate }}
  </button>
</div>
